import { useSelectedModelsSettingsAndActions } from "../../boardState/hooks/useSelectedModelsSettingsAndActions.ts";
import { boardModelPickerStore } from "../../boardState/stores/boardModelPickerStore.ts";
import { useBoardUuid } from "../hooks/useBoardUuid.ts";
import { ModelPickerDialog } from "./ModelPickerDialog.tsx";

export const ModelPicker = () => {
  const { isOpen, modelType, initialSelectedModelUuid, tool } =
    boardModelPickerStore.useState();
  const boardUuid = useBoardUuid();

  const { modelActions, allModels } = useSelectedModelsSettingsAndActions(
    tool,
    boardUuid,
    initialSelectedModelUuid,
  );

  return (
    <ModelPickerDialog
      models={allModels}
      dialogOpen={isOpen ?? false}
      onDialogChange={() => boardModelPickerStore.reset()}
      onModelSelect={(model) => {
        if (
          initialSelectedModelUuid &&
          initialSelectedModelUuid !== model.uuid
        ) {
          modelActions.removeModel(initialSelectedModelUuid);
        }
        modelActions.addModel(model.uuid, model.is_trained);
        boardModelPickerStore.reset();
      }}
      initialSelectedModelUuid={initialSelectedModelUuid}
      modelType={modelType}
    />
  );
};
